<template>
  <div class="home-page-toggle">
    <HomePageV2
      v-if="canUseNewPresenterHomepage"
      v-aha-emit-action.view
      name="homepageV2"
    />
    <HomePageOriginal
      v-else
      v-aha-emit-action.view
      name="homepageOriginal"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HomePageOriginal from '@/components-v2/home/HomePage.vue'
import HomePageV2 from '@/components-v2/home/HomePage.v2.vue'

export default {
  name: 'HomePageToggle',
  components: {
    HomePageOriginal,
    HomePageV2,
  },
  computed: {
    ...mapGetters('featureToggles', ['canUseNewPresenterHomepage']),
  },
}
</script>
